import React from 'react'

interface ChatLiveDramaIconProps {
  size?: number
  color?: string
  className?: string
}

export const ChatLiveDramaIcon: React.FC<ChatLiveDramaIconProps> = ({
  size = 32,
  color = '#FFFFFF',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.833 0C16.6496 3.48054e-05 18.9326 2.28298 18.9326 5.09961V6.70703L21.9277 5.02246C22.4966 4.70249 23.1992 5.11395 23.1992 5.7666V13.8994C23.1992 14.5521 22.4966 14.9635 21.9277 14.6436L18.9326 12.958V13.833C18.9326 16.6496 16.6496 18.9326 13.833 18.9326H5.09961C2.28298 18.9326 3.46616e-05 16.6496 0 13.833V5.09961C0 2.28296 2.28296 0 5.09961 0H13.833ZM5.09961 1.19922C2.9457 1.19922 1.19922 2.9457 1.19922 5.09961V13.833C1.19925 15.9869 2.94572 17.7334 5.09961 17.7334H13.833C15.9869 17.7334 17.7334 15.9869 17.7334 13.833V5.09961C17.7334 2.94572 15.9869 1.19925 13.833 1.19922H5.09961ZM18.9326 8.08301V11.582L22 13.3076V6.3584L18.9326 8.08301ZM6.9668 6.51855C6.9668 5.86166 7.67818 5.45085 8.24707 5.7793L13.1865 8.63086L13.2861 8.69824C13.7219 9.03617 13.7219 9.70409 13.2861 10.042L13.1865 10.1094L8.24707 12.9619C7.67843 13.29 6.96732 12.8791 6.9668 12.2227V6.51855ZM8.16699 11.6211L12.0674 9.37012L8.16699 7.11914V11.6211Z"
        fill={color}
        transform="translate(6.5, 6.5)"
      />
    </svg>
  )
}
